import React, { useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { formatDatePickerDate, getUsersName } from 'utils/formatting';
import { UsersContextProvider } from 'context/users.context';
import { CampaignsContextProvider, useCampaignsContext } from 'pages/Campaigns/campaigns.context';
import { StoresContextProvider } from 'pages/Stores/stores.context';
import ArchiveCampaign from 'pages/Campaigns/ArchiveCampaign';
import UpdateCampaign from 'pages/Campaigns/UpdateCampaign';
import { Store, User } from '@restore/services-lib';
import Overview from 'components/Overview/Overview';
import { OverviewDetailInterface } from 'components/Overview/overview.types';
import { Div } from 'components/Elements/Div/Div';

const CampaignComponent = () => {
  const { campaignId } = useParams();
  const { getCampaignById, loading } = useCampaignsContext();
  const campaign = getCampaignById(Number(campaignId));
  const navigate = useNavigate();

  useEffect(() => {
    if (!loading && !campaign) {
      navigate('/campaigns');
    }
  }, [campaign, loading, navigate]);

  if (!campaign) {
    return null;
  }

  const details: OverviewDetailInterface[] = [
    { title: 'Name', value: campaign.name },
    {
      title: 'Stores',
      value: campaign.stores.map((store: Store) => store.name).join(', '),
    },
    {
      title: 'Users',
      value: campaign.users.map((user: User) => getUsersName(user)).join(', '),
    },
    {
      title: 'Start Date',
      value: formatDatePickerDate(campaign.startDate),
    },
    {
      title: 'End Date',
      value: formatDatePickerDate(campaign.endDate, 'Ongoing'),
    },
  ];

  const actions = (
    <Div display='flex' gap='0.75rem' alignItems='flex-end'>
      <UpdateCampaign campaign={campaign} />
      <ArchiveCampaign campaign={campaign} />
    </Div>
  );

  return (
    <Overview
      title={campaign.name}
      entityType='Campaign'
      customDetails={details}
      tags={campaign.tags}
      actions={actions}
    />
  );
};

const Campaign = () => (
  <CampaignsContextProvider>
    <StoresContextProvider>
      <UsersContextProvider>
        <CampaignComponent />
      </UsersContextProvider>
    </StoresContextProvider>
  </CampaignsContextProvider>
);

export default Campaign;
